import { createTheme } from '../utils';
import * as SocialAuth from './components/SocialAuth.css';

export const defaultTheme = {
	SocialAuth
};
export default { SocialAuth };

export const { useTheme, Provider } = createTheme<typeof defaultTheme>(defaultTheme);
